import { X } from '@music-vine/cadence/icons';
import Modal from '@/components/Modals/Core';
import { useSidebarHeaderContext } from '@/components/Modals/Sidebar/context/SidebarHeaderContext';
import { Button } from '@music-vine/cadence/ui';
const SidebarHeader = () => {
  const {
    tabs
  } = useSidebarHeaderContext();
  return <div className="sticky top-0 z-10 flex shrink-0 items-center justify-between overflow-hidden" data-sentry-component="SidebarHeader" data-sentry-source-file="SidebarHeader.tsx">
      {tabs.length > 1 ? <div className="relative flex h-16 w-full items-center justify-between bg-gray-50 p-4 dark:bg-gray-900">
          {tabs}
          <Modal.Close asChild>
            <Button borderRadius="full" className="size-6" icon variant="light">
              <X className="size-4" />
            </Button>
          </Modal.Close>
        </div> : <div className="flex h-[4.5rem] w-full items-center justify-between border-0 border-b-1 border-b-gray-150 border-solid bg-white px-6 py-4 dark:border-b-gray-800 dark:bg-gray-900">
          {tabs}
          <Modal.Close asChild>
            <Button borderRadius="full" className="size-6" icon variant="light">
              <X className="size-4" />
            </Button>
          </Modal.Close>
        </div>}
    </div>;
};
export default SidebarHeader;